{
  "app.name": "404 OS",
  "app.tagline": "The operating system of 404 Creative",
  "auth.signIn.title": "Sign in to 404 OS",
  "auth.signIn.subtitle": "For the 404 Creative team.",
  "auth.email": "Work email",
  "auth.password": "Password",
  "auth.showPassword": "Show password",
  "auth.hidePassword": "Hide password",
  "auth.submit": "Sign in",
  "auth.submitting": "Signing in…",
  "auth.signOut": "Sign out",
  "auth.errors.email": "Enter a valid email address.",
  "auth.errors.password": "Enter your password.",
  "auth.brand.headline": "Every client, project and task in one calm place.",
  "auth.brand.point1": "Plan in milestones, each with its own phases.",
  "auth.brand.point2": "Know what everyone is working on, without asking.",
  "auth.brand.point3": "Keep clients informed and every approval on record.",
  "nav.myWork": "My work",
  "nav.projects": "Projects",
  "nav.clients": "Clients",
  "nav.group.work": "Work",
  "nav.group.agency": "Agency",
  "nav.group.sales": "Sales",
  "topbar.search": "Search or jump to…",
  "topbar.switchLanguage": "العربية",
  "topbar.accountMenu": "Account menu",
  "header.language": "Language",
  "role.owner": "Owner",
  "role.admin": "Admin",
  "role.finance": "Finance",
  "role.pm": "Project manager",
  "role.member": "Team member",
  "role.contractor": "Contractor",
  "service.web": "Web & e-commerce",
  "service.mobile": "Mobile apps",
  "service.automation": "Automation & AI",
  "service.marketing": "Growth marketing",
  "projects.title": "Projects",
  "projects.subtitle": "Everything the team is delivering right now.",
  "projects.new": "New project",
  "projects.empty.title": "No projects yet",
  "projects.empty.body": "Create the first project to start planning tasks with the team.",
  "projects.loadError": "We could not load the projects.",
  "newProject.title": "New project",
  "newProject.description": "A project groups the tasks, people and money of one client engagement.",
  "newProject.name": "Project name",
  "newProject.namePlaceholder": "Noon storefront redesign",
  "newProject.key": "Project key",
  "newProject.service": "Service",
  "newProject.create": "Create project",
  "newProject.creating": "Creating…",
  "newProject.created": "Project {key} created.",
  "newProject.errors.name": "Use at least 2 characters.",
  "newProject.errors.key": "Use 2–10 letters or digits, starting with a letter.",
  "board.status.backlog": "Backlog",
  "board.status.todo": "To do",
  "board.status.in_progress": "In progress",
  "board.status.in_review": "In review",
  "board.status.done": "Done",
  "board.status.cancelled": "Cancelled",
  "board.addTask": "Add task",
  "board.addTaskPlaceholder": "What needs to be done?",
  "board.addTaskHint": "Enter to add · Esc to cancel",
  "board.moveError": "The board changed while you were moving that task, so it was refreshed.",
  "board.loadError": "We could not load this board.",
  "board.dnd.instructions": "To pick up a task, press Space. Use Left and Right to carry it to another column and Up and Down to reorder it, then press Space to drop it, or Escape to cancel. Press Enter to open it.",
  "board.dnd.picked": "Picked up {title}.",
  "board.dnd.over": "{title} is over {column}.",
  "board.dnd.dropped": "{title} was dropped in {column}.",
  "board.dnd.cancelled": "Moving {title} was cancelled.",
  "palette.title": "Command palette",
  "palette.placeholder": "Type a command or search…",
  "palette.empty": "No results.",
  "palette.navigation": "Go to",
  "palette.projects": "Projects",
  "palette.actions": "Actions",
  "palette.newProject": "Create a new project",
  "palette.newTask": "Create a new task",
  "palette.switchLanguage": "Switch to Arabic",
  "palette.signOut": "Sign out",
  "common.retry": "Try again",
  "common.cancel": "Cancel",
  "common.close": "Close",
  "date.pick": "Pick a date",
  "errors.generic": "Something went wrong. Please try again.",
  "errors.network": "We could not reach the server. Check your connection.",
  "errors.notFound.title": "Page not found",
  "errors.notFound.body": "The page you are looking for does not exist or has moved.",
  "errors.notFound.home": "Go to projects",
  "auth.errors.invalid": "The email or password is incorrect.",
  "newProject.errors.keyTaken": "Another project already uses this key.",
  "shell.skipToContent": "Skip to content",
  "shell.mainNavigation": "Main navigation",
  "shell.collapseSidebar": "Collapse the sidebar",
  "shell.expandSidebar": "Expand the sidebar",
  "palette.open": "Open the command palette",
  "board.columnTasks": "{column}: {count, plural, =0 {no tasks} one {# task} other {# tasks}}",
  "errors.unexpected.body": "An unexpected error stopped this page. Reload to try again.",
  "shell.openMenu": "Open the menu",
  "shell.breadcrumb": "Breadcrumb",
  "shell.moreTabs": "More",
  "palette.hintMove": "to move",
  "palette.hintOpen": "to open",
  "projects.stats.active": "Active projects",
  "projects.stats.open": "Open tasks",
  "projects.stats.progress": "Overall progress",
  "projects.filter.label": "Filter by service",
  "projects.search": "Search projects",
  "projects.columns.project": "Project",
  "projects.columns.progress": "Progress",
  "projects.columns.open": "Open",
  "projects.progress": "{done, number} of {total, number} done",
  "projects.noResults.title": "No matching projects",
  "projects.noResults.body": "Try another name, key or service.",
  "projects.noResults.clear": "Clear filters",
  "project.tabs.label": "Project views",
  "project.tabs.board": "Board",
  "project.tabs.overview": "Overview",
  "project.newTask": "New task",
  "project.ownTasksOnly": "Your tasks only",
  "project.ownTasksOnly.hint": "In this project you see the tasks you created or are assigned to. Progress counts the whole project.",
  "project.status.active": "Active",
  "project.status.on_hold": "On hold",
  "project.status.completed": "Completed",
  "project.status.archived": "Archived",
  "overview.progress.title": "Progress",
  "overview.breakdown.title": "Tasks by status",
  "overview.recent.title": "Recently updated",
  "overview.recent.empty": "Tasks you add will show up here.",
  "overview.details.title": "Details",
  "overview.details.key": "Key",
  "overview.details.status": "Status",
  "task.dialogLabel": "Task {reference}",
  "task.titleLabel": "Task title",
  "task.properties": "Properties",
  "task.status": "Status",
  "task.project": "Project",
  "task.noProject": "No project",
  "task.moveToProject.action": "Move to project",
  "task.moveToProject.title": "Move {reference} to a project",
  "task.moveToProject.body": "It takes the project's next number. Its subtasks, comments and history move with it.",
  "task.moveToProject.confirm": "Move task",
  "task.moveToProject.moving": "Moving…",
  "task.moveToProject.done": "Moved. The task is now {reference}.",
  "task.moveToProject.notMembers": "Someone assigned to this task is not on that project. Add them to the project or unassign them first.",
  "task.moveToProject.forbidden": "You can't add tasks to that project.",
  "task.projectPicker.choose": "Choose a project",
  "task.projectPicker.search": "Search projects",
  "task.projectPicker.empty": "No project matches.",
  "task.projectPicker.none": "There is no project you can add tasks to yet.",
  "task.created": "Created",
  "task.updated": "Updated",
  "task.completed": "Completed",
  "task.copyLink": "Copy link",
  "task.linkCopied": "Link copied.",
  "task.notFound": "This task no longer exists.",
  "task.close": "Close task",
  "task.changeStatus": "Change status",
  "newTask.title": "New task",
  "newTask.description": "Add it to the board; you can move it any time.",
  "newTask.descriptionAnywhere": "Put it in a project, or leave it outside one for now and move it later.",
  "newTask.projectLabel": "Project",
  "newTask.titleLabel": "Title",
  "newTask.statusLabel": "Status",
  "newTask.create": "Create task",
  "newTask.creating": "Creating…",
  "newTask.created": "Task {reference} created.",
  "newTask.errors.title": "Write a title.",
  "auth.preview.label": "A project board in 404 OS",
  "auth.preview.project": "Storefront redesign",
  "auth.preview.task1": "Homepage wireframes",
  "auth.preview.task2": "WhatsApp lead flow",
  "auth.preview.task3": "Meta ads launch plan",
  "auth.preview.task4": "Client brief review",
  "board.addTaskTo": "Add a task to {column}",
  "task.open": "Open",
  "task.conflict": "Someone else changed this task, so it was refreshed. Try again.",
  "task.notFoundBody": "It may have been deleted, or the link is incomplete.",
  "overview.details.service": "Service",
  "overview.details.created": "Created",
  "overview.details.tasks": "Tasks",
  "project.notFound.title": "Project not found",
  "project.notFound.body": "Its key may have changed, or you may not have access to it.",
  "project.loadError": "We could not load this project.",
  "common.copy": "Copy",
  "common.copied": "Copied",
  "common.copiedToast": "Copied to the clipboard.",
  "common.copyFailed": "Could not copy. Select the text and copy it yourself.",
  "combobox.clear": "Clear selection",
  "errors.invalidValue": "This value was not accepted. Check it and try again.",
  "errors.validation": "Some details were not accepted. Check them and try again.",
  "errors.forbidden": "You do not have permission to do that.",
  "errors.conflict": "Someone else changed this in the meantime. Reload and try again.",
  "theme.title": "Appearance",
  "theme.system": "System",
  "theme.light": "Light",
  "theme.dark": "Dark",
  "palette.theme.system": "Match the system theme",
  "palette.theme.light": "Switch to the light theme",
  "palette.theme.dark": "Switch to the dark theme",
  "palette.theme.current": "(current)",
  "auth.help": "Trouble signing in? Ask the person who invited you to 404 OS.",
  "auth.reset.forgot": "Forgot password?",
  "auth.reset.title": "Reset your password",
  "auth.reset.subtitle": "Enter the work email you use to sign in. If it is on 404 OS, we will send a 4-digit code.",
  "auth.reset.submit": "Send code",
  "auth.reset.submitting": "Sending…",
  "auth.reset.back": "Back to sign in",
  "auth.reset.sentTitle": "Check your email",
  "auth.reset.sentSubtitle": "Enter the 4-digit code we sent to {email}.",
  "auth.reset.codeLabel": "Verification code",
  "auth.reset.digit": "Digit {position}",
  "auth.reset.verifying": "Checking…",
  "auth.reset.resend": "Send a new code",
  "auth.reset.resendIn": "Resend in {seconds}s",
  "auth.reset.newTitle": "Choose a new password",
  "auth.reset.newSubtitle": "Then you will be signed in, and your other devices will be signed out.",
  "auth.reset.newSubmit": "Save password and sign in",
  "auth.reset.newSubmitting": "Saving…",
  "auth.reset.confirm": "Confirm password",
  "auth.reset.errors.otp": "That code is not valid. Check it and try again.",
  "auth.reset.errors.rateLimited": "Too many attempts. Wait a few minutes, then try again.",
  "auth.reset.errors.mismatch": "The two passwords do not match.",
  "auth.reset.errors.length": "Use at least 10 characters.",
  "auth.preview.task5": "Brand guidelines",
  "auth.preview.doneThisWeek": "Done this week",
  "auth.preview.toast": "Nour moved WhatsApp lead flow to In review",
  "errors.notFound.search": "Search 404 OS",
  "errors.unexpected.title": "This page stopped working",
  "errors.unexpected.home": "Back to home",
  "realtime.live": "Live",
  "realtime.connecting": "Connecting",
  "realtime.offline": "Offline",
  "realtime.liveHint": "Changes from your team appear as they happen",
  "realtime.connectingHint": "Connecting to live updates",
  "realtime.offlineHint": "Live updates are paused. We keep trying in the background.",
  "reason.label": "Reason",
  "reason.tooShort": "Write a reason of at least {min} characters.",
  "changeStamp.by": "Changed by {name} · {when}",
  "dataTable.sortBy": "Sort by {column}",
  "dataTable.selectAll": "Select all rows",
  "dataTable.selectRow": "Select {name}",
  "role.hr": "HR"
}
